import sortAlphabeticalNoSymbol from "./sortAlphabeticalNoSymbol";

const mkplIntegrationCategories = [
  { label: "Partner Onboarding", value: "Partner-Onboarding" },
  {
    label: "Authentication and Security",
    value: "Authentication-and-Security",
  },
  { label: "Storefront Integration", value: "Storefront-Integration" },
  { label: "Single Sign-On", value: "Single-Sign-On" },
  { label: "Marketing and Sales", value: "Marketing-and-Sales" },
  { label: "International", value: "International" },
];

const productIntegrationcategories = [
    {
        group: 'North America',
        items: [
            { label: 'Recruiting', value: 'Recruiting' },
            { label: 'Human Resources', value: 'Human-Resources' },
            { label: 'Time & Labor Management', value: 'Time-Labor-Management' },
            { label: 'Payroll Management', value: 'Payroll-Management' },
            { label: 'Benefit Management', value: 'Benefit-Management' },
            { label: 'Compliance Solutions', value: 'Compliance-Solutions' },
        ]
    },
];

const adpNorthAmericaProduct = [
  {
    label: "ADP Workforce Now®",
    value: "ADP Workforce Now®",
    id: "hcm-offrg-wfn",
  },
  {
    label: "ADP® Workforce Manager",
    value: "ADP® Workforce Manager",
  },
  {
    label: "RUN Powered by ADP®",
    value: "RUN Powered by ADP®",
    id: "pr-offrg-run",
  },
  {
    label: "ADP® Vantage HCM",
    value: "ADP® Vantage HCM",
    id: "hcm-offrg-vantg",
  },
  {
    label: "ADP Enterprise HR®",
    value: "ADP Enterprise HR®",
    id: "hcm-offrg-ent",
  },
  {
    label: "ADP Lyric",
    value: "ADP Lyric",
    id: "hcm-offrg-lifion",
  },
  {
    label: "ADP® Recruiting Management",
    value: "ADP® Recruiting Management",
    id: "tal-offrg-tal.rcrtg",
  },
  {
    label: "ADP SmartCompliance® Tax Credits",
    value: "ADP SmartCompliance® Tax Credits",
    id: "tax-offrg-tcs",
  },
  {
    label: "ADP® DataCloud Embedded Direct Deposit Enablement",
    value: "ADP® DataCloud Embedded Direct Deposit Enablement",
  },
  {
    label: "ADP® DataCloud Employment and Income Verification",
    value: "ADP® DataCloud Employment and Income Verification",
    id: "anlyt-offrg-data.cld",
  },
  {
    label: "ADP Workforce Now® Next Generation",
    value: "ADP Workforce Now® Next Generation",
    id: "hcm-offrg-wfn.next.gen",
  },
  {
    label: "ADP® Next Gen Payroll",
    value: "ADP® Next Gen Payroll",
    id: "pr-offrg-pi",
  },
  {
    label: "ADP SmartCompliance®",
    value: "ADP SmartCompliance®",
    id: "cp-offrg-smart.cp",
  },
  {
    label: "ADP Screening and Selection Services",
    value: "ADP Screening and Selection Services",
    id: "tal-offrg-sass",
  },
  {
    label: "ADP Insurance Services",
    value: "ADP Insurance Services",
    id: "ins-offrg-ins.svcs",
  },
  {
    label: "ADP® Embedded Payroll",
    value: "ADP® Embedded Payroll",
    id: "pr-offrg-adp.embdd.pr",
  },
  {
    label: "ADP Workforce Now On the Go®",
    value: "ADP Workforce Now On the Go®",
    id: "hcm-offrg-wfn.otg",
  },
  {
    label: "ADP® WorkForce Suite",
    value: "ADP® WorkForce Suite",
    id: "wfm-offrg-wkfc.sw",
  },
  {
    label: "ADP General Ledger",
    value: "ADP General Ledger",
    id: "acctg-offrg-gnl.ldgr",
  },
];

const adpIternationalProduct = [
  {
    label: "ADP® Link",
    value: "ADP® Link",
    id: "pr-offrg-adp.link.prem",
  },
  {
    label: "ADP DECIDIUM®",
    value: "ADP DECIDIUM®",
    id: "hcm-offrg-dge",
  },
  {
    label: "ADP® iHCM (UK)",
    value: "ADP® iHCM (UK)",
    id: "hcm-offrg-ihcm.2-g.gb",
  },
  {
    label: "ADP® iHCM (NL)",
    value: "ADP® iHCM (NL)",
    id: "hcm-offrg-ihcm.2-g.nl",
  },
  {
    label: "ADP® iHCM (MC)",
    value: "ADP® iHCM (MC)",
    id: "hcm-offrg-ihcm.2-g.001",
  },
    {
    label: "ADP Lyric (International)",
    value: "ADP Lyric (International)",
    id: "hcm-offrg-lifion-g.001",
  },
  {
    label: "ADP® Workforce",
    value: "ADP® Workforce",
    id: "hcm-offrg-wkfc",
  },
  {
    label: "ADP eXpert®",
    value: "ADP eXpert®",
  },
  {
    label: "ADP GlobalView®",
    value: "ADP GlobalView®",
  },
  {
    label: "ADP Celergo®",
    value: "ADP Celergo®",
  },
  {
    label: "ADP® Time Connect",
    value: "ADP® Time Connect",
    id: "ta-offrg-gta",
  },
  {
    label: "ADP eService-Case Management",
    value: "ADP eService-Case Management",
    id: "crm-int-siebel.crm-g.fr-o.oracle",
  },
  {
    label: "ADP® AdvancedPay",
    value: "ADP® AdvancedPay",
    id: "pr-offrg-paisy.advd",
  },
  {
    label: "ADP® OneService",
    value: "ADP® OneService",
    id: "hcm-offrg-sipert",
  },
  {
    label: "ADP Global Payroll Portal",
    value: "ADP Global Payroll Portal",
    id: "prtl-core-glob.my.vw.prtl-g.fr",
  },
].sort((a, b) => sortAlphabeticalNoSymbol(a, b, "label"));

const findFromProductsAndId = (products, productId) =>
  products.find((product) => {
    if (!productId) return;
    return product.id && product.id === productId;
  });
const findProductFromId = (productId) =>
  findFromProductsAndId(adpNorthAmericaProduct, productId) ||
  findFromProductsAndId(adpIternationalProduct, productId);
  function getBreadcrumb(pageName, articleTitle, articleLink) {
    const baseHome = { name: "Home", route: "/" };
    const baseGuides = { name: "Guides" };
    const baseGettingStarted = { name: "Getting Started" };
    
    const configs = {
      "key-concepts": [
        baseHome,
        { name: "Getting Started / Key Concepts", route: "/getting-started/key-concepts" },
        { name: articleTitle }
      ],
      "how-to-articles": [
        baseHome,
        { name: "How-to Articles", route: "/getting-started/how-to-articles" },
        { name: articleTitle }
      ],
      "adp-marketplace-integration-guides": {
        base: [baseHome, baseGuides, { name: "ADP Marketplace Integration Guides", route: "/guides/adp-marketplace-integration-guides" }],
        linkRoute: (link) => `/guides/adp-marketplace-integration-guides/${link}`
      },
      "api-guides": {
        base: [baseHome, baseGuides, { name: "API Guides", route: "/guides/api-guides" }],
        linkRoute: (link) => `/guides/api-guides/${link}`
      },
      "getting-started-client": [
        baseHome,
        { name: "Getting Started" },
        { name: "Client Integration Overview", route: "/getting-started/client-integration-overview" },
        ...(articleLink ? [{ name: articleTitle }] : [])
      ],
      "getting-started-client-quick-start-guide": [
        baseHome,
        { name: "Getting Started" },
        { name: "Getting started as a client", route: "/getting-started/getting-started-as-a-client/guides/api-guides/api-central-quick-start-guide" },
        ...(articleLink ? [{ name: articleTitle }] : [])
      ],
      "getting-started-as-a-client": {
        base: [baseHome, baseGettingStarted],
        linkRoute: (link) => `/getting-started/getting-started-as-a-client/guides/api-guides/${link}`
      },
      "getting-started-partner": [
        baseHome,
        { name: "Getting Started" },
        { name: "Partner Integration Overview", route: "/getting-started/getting-started-as-a-partner/guides/adp-marketplace-integration-guides/partner-development-learning-guide" },
        ...(articleLink ? [{ name: articleTitle }] : [])
      ]
    };

    const config = configs[pageName];
    if (!config) return [];
    
    if (config.base && config.linkRoute) {
      return articleLink 
        ? [...config.base, { name: articleLink[1], route: config.linkRoute(articleLink[0]) }, { name: articleTitle }]
        : [...config.base, { name: articleTitle }];
    }
    
    return config;
  }

const isFetching = (query) => query.isLoading || query.status === "pending";

export {
  mkplIntegrationCategories,
  productIntegrationcategories,
  adpNorthAmericaProduct,
  adpIternationalProduct,
  getBreadcrumb,
  findProductFromId,
  isFetching,
};